import React, { Component } from 'react'
import Helmet from "react-helmet";
import style from '../largeheader/style.css'
import { toggleOverlay, updateScroll, updateBooking } from '../../store/reducers';
// import { CSSTransitionGroup } from 'react-transition-group'
import { Switch, Route, withRouter } from 'react-router-dom'
import {connect} from 'react-redux';
import Home from '../../routes/home';
import AsyncRoute from '../../lib/asyncroute';
// import TrustYou from '../layouts/trustyou';
// import MapView from '../../routes/map';
// import Form from '../../routes/form';
// import Resort from '../../routes/resort';
// import Room from '../../routes/room';
// import Page from '../../routes/page';
// import SiteMap from '../../routes/sitemap';
// import BookYourStay from '../../routes/bookyourstay';
// import AwardsList from '../../components/awardslist';
// import AwardPage from '../../components/layouts/awardpage';

import PagePlain from '../layouts/pageplain';


const NotFoundPage = () => {
    return(
        <div>Page Not Found</div>
    )
}


// const Room = AsyncRoute('room')
// const Resort = AsyncRoute('resort')
const Page = AsyncRoute('page')
const Form = AsyncRoute('form')
const News = AsyncRoute('news')
const MapView = AsyncRoute('map')
const TrustYou = AsyncRoute('trustyou')
const BookYourStay = AsyncRoute('bookyourstay')
// const SplashScreen = AsyncRoute('splashscreen')

class MasterLayout extends Component {

    constructor(props){
        super(props);
        this.state = { scrollDirection: null, is_bottom: false, is_top: true };
        this.lastScrollPosition = 0
        this.scrollDirection = 0
        this.handleScroll = this.handleScroll.bind(this);
        this.storeParseSearchParams = this.storeParseSearchParams.bind(this);

        this.currentPage = this.props.location.pathname;

        this.pages = {
            '/': 0,
            '/sitemap': 5,
            '/booking_request': 5,
            '/Home/SHARM_EL_SHEIKH/SUNRISE_Grand_Select_Montemare_Resort_Adults_Only': 1,
            '/Home/SHARM_EL_SHEIKH/SUNRISE_Grand_Select_Arabian_Beach_Resort': 1,
            '/Home/SHARM_EL_SHEIKH/SUNRISE_Select_Diamond_Beach_Resort': 1,
            '/Home/HURGHADA/SUNRISE_Grand_Select_Crystal_Bay_Resort': 1,
            '/Home/HURGHADA/SUNRISE_Select_Royal_Makadi_Resort': 1,
            '/Home/HURGHADA/SUNRISE_Select_Garden_Beach_Resort_Spa': 1,
            '/Home/HURGHADA/SUNRISE_Select_Holidays_Resort_Adults_Only': 1,
            '/Home/HURGHADA/SUNRISE_Select_Mamlouk_Palace': 1,
        }
    }
    static scrollPositions = {};

    getSlideOrder(url){
        const _home_ = /Home/i
        const _root_ = /^\/$/
        const _booking_ = /booking_request/
        const _sitemap_ = /sitemap/
        const _room_ = /room/
        if((_root_).test(url)){ return(0) } 
        else if((_room_).test(url)){ return(2) }
        else if((_home_).test(url)){ return(1) }
        else if((_sitemap_).test(url)){ return(5) }
        else if((_booking_).test(url)){ return(5) }
    }
    getDirection() {//{{{
        const { location } = this.props
        let nextPage = location.pathname;
        // let nextPageIndex = this.pages[nextPage];
        // let currentPageIndex = this.pages[this.currentPage];
        let nextPageIndex = this.getSlideOrder(nextPage);
        let currentPageIndex = this.getSlideOrder(this.currentPage);

        this.currentPage = location.pathname;

        if (currentPageIndex < nextPageIndex) {
            return 'rtl'
        } else if (currentPageIndex > nextPageIndex){
            return 'ltr'
        }

        return null;
    }//}}}
    getAnimation() {//{{{
        let direction = this.getDirection();
        let calculatedAnimations = {};
        let animationPrefix = 'navigation';

        if (direction === 'rtl') {
            calculatedAnimations.enter = `${animationPrefix}-enter-rtl`;
            calculatedAnimations.enterActive = `${animationPrefix}-enter-active`;
            calculatedAnimations.leave = `${animationPrefix}-leave-rtl`;
            calculatedAnimations.leaveActive = `${animationPrefix}-leave-active`;
        } else if (direction === 'ltr'){
            calculatedAnimations.enter = `${animationPrefix}-enter-ltr`;
            calculatedAnimations.enterActive = `${animationPrefix}-enter-active`;
            calculatedAnimations.leave = `${animationPrefix}-leave-ltr`;
            calculatedAnimations.leaveActive = `${animationPrefix}-leave-active`;
        } else {
            calculatedAnimations.enter = `${animationPrefix}-enter-fade`;
            calculatedAnimations.enterActive = `${animationPrefix}-enter-active`;
            calculatedAnimations.leave = `${animationPrefix}-leave-fade`;
            calculatedAnimations.leaveActive = `${animationPrefix}-leave-active`;
        }

        return calculatedAnimations;
    }//}}}
    getAnimationSpeed() {//{{{
        let direction = this.getDirection();

        /*
         * Time values must be equal to $naviagtion-animation-time-cross-page and $naviagtion-animation-time-current-page @ variables.scss
         */
        const activePageAnimationSpeed = 300;
        const crossPageAnimationSpeed = 150;

        if (direction === null) {
            return activePageAnimationSpeed
        }

        return crossPageAnimationSpeed;
    }//}}}

    handleScroll(event) {//{{{
        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight,  html.scrollHeight, html.offsetHeight);
        const windowBottom = windowHeight + window.pageYOffset;
        let newState = null
        let current_scroll_pos = 0

        windowBottom >= docHeight && !(this.props.scroll.is_bottom) && ( newState = { is_bottom: true } )
        windowBottom < docHeight && this.props.scroll.is_bottom && ( newState = { is_bottom: false } )
        
        window.pageYOffset < 100 && !(this.props.scroll.is_top) && ( newState = { is_top: true } )
        window.pageYOffset > 100 && this.props.scroll.is_top && ( newState = { is_top: false } )
        
        current_scroll_pos = window.pageYOffset
        if(this.lastScrollPosition > current_scroll_pos) {
            this.scrollDirection = 'top'
            this.lastScrollPosition = current_scroll_pos
        }
        if(this.lastScrollPosition < current_scroll_pos) {
            this.scrollDirection = 'bottom'
            this.lastScrollPosition = current_scroll_pos
        }
        ( this.props.scroll.scrollDirection !== this.scrollDirection ) && ( newState = Object.assign(newState || {},{ scrollDirection: this.scrollDirection }))


        if(newState) { this.props._update_scroll(newState) }
    }//}}}
    componentDidMount() {//{{{
        this.storeParseSearchParams()
        window.addEventListener("scroll", this.handleScroll);
        // console.log("Posts Did Mount")
    }//}}}
    componentWillUnmount() {//{{{
        window.removeEventListener("scroll", this.handleScroll);
        // console.log("Posts Will unMount")
    }//}}}

  storeParseSearchParams() {
    const search = this.props.location.search; //  like '?discount=promocode'
    const params = new URLSearchParams(search);
    const discount = params.get('discount'); // bar
    console.log("Found Discount: " + discount )
    this.props.updateBooking({discount: discount})
  }
    //Restore Scroll Position
    componentWillReceiveProps(nextProps) {//{{{
        // console.log("I am MasterLayout I am receiving props");
        // console.log("MasterLayout:componentWillReceiveProps: this pathname " + JSON.stringify(this.props.location.pathname))
        // console.log("MasterLayout:componentWillReceiveProps: next pathname " + JSON.stringify(nextProps.location.pathname))
        if(nextProps.location.pathname !== this.props.location.pathname){
            //Save current window scrolling position
            const winHeight = window.scrollY; //window.innerHeight;
            MasterLayout.scrollPositions[this.props.location.pathname] = winHeight;
            // console.log("MasterLayout: Page Scroll Postions:" + JSON.stringify(MasterLayout.scrollPositions))

        }
    }//}}}
    componentDidUpdate(prevProps, prevState) {//{{{
        // console.log("MasterLayout: ComponentDidUpdate fired!")
        // console.log("MasterLayout:componentdidupdate: this pathname " + JSON.stringify(this.props.location.pathname))
        // console.log("MasterLayout:componentdidupdate: prev pathname " + JSON.stringify(prevProps.location.pathname))
        if(this.props.location.pathname !== prevProps.location.pathname){
            // console.log("I am MasterLayout I am updating and have a new location");
            let scrollToTop = this.props.location.hash.length === 0;
            //Restore position
            const pos = MasterLayout.scrollPositions[this.props.location.pathname];
            // console.log(`MasterLayout: ${this.props.history.action} Action in ${this.props.location.pathname} = ${pos}`);
            if (this.props.history.action === 'POP') {
                this.props._toggle_overlay(false);
                if (pos) {
                    window.scroll(0, parseInt(pos));
                    scrollToTop = false;
                }
            }
            if (scrollToTop) {
            // Scroll to top of viewport
                window.scroll(0, 0);
            }
            
        }
    }//}}}

    render() {
        const { location } = this.props
        const is_grand = this.props.location.pathname && (/Grand/i).test(this.props.location.pathname)
        const greater_than = this.props.browser.greaterThan
        const greater_thans = Object.keys(greater_than).filter((i) => { return greater_than[i] } ).map((i) => { return(`is_gt_${i}`) }).join(" ")
        const less_than = this.props.browser.lessThan
        const less_thans = Object.keys(less_than).filter((i) => { return less_than[i] } ).map((i) => { return(`is_lt_${i}`) }).join(" ")
        return (
            <div>
                <Helmet>
                    <body className={`is_${ this.props.browser.orientation } ${ less_thans } ${ greater_thans } is_${this.props.browser.mediaType} ${is_grand ? 'is_grand' : 'is_select' } direction${this.props.scroll.scrollDirection} ${this.props.scroll && this.props.scroll.is_top ? 'is_top' : 'not_top' } ${ this.props.scroll && this.props.scroll.is_top ? style.fadingMenu : style.noFadingMenu } ${this.props.overlay ? 'noscroll' : ''}`} />
                </Helmet>
                <Switch key={location.key} location={location}>
                    <Route path="/" exact component={Home} />
                    <Route path="/app" exact component={Home} />
                    <Route path="/topics/:topic_id/posts/:post_id" exact render={ (props) => <PagePlain { ...props } /> } />
                    <Route path="/posts/:post_id" exact render={ (props) => <PagePlain { ...props } /> } />
                    <Route path="/experiences/SUNRISE_CONCEPTS/578" exact render={ (props) => <Page layout="Concepts" { ...props } /> } />
                    <Route path="/page/:pagetitle/:page_id" exact component={Page} />
                    <Route path="/experiences/:pagetitle/:page_id" exact component={Page} />
                    <Route path="/activities/:pagetitle/:page_id" exact component={Page} />
                    <Route path="/offers" exact render={ (props) => <Page layout="Offers" { ...props } /> } />
                    <Route path="/offers/:pagetitle/:page_id" exact component={Page} />
                    <Route path="/awards/:pagetitle/:page_id" exact render={ (props) => <Page layout="AwardPage"  {...props} /> } />
                    <Route path="/Home/:destination/:resort/room/:room/:roomtitle" exact render={ (props) => <Page layout="Room" {...props} /> } />
                    <Route path="/Home/:destination/:resort/dining/:page_id/:diningtitle" exact render={ (props) => <Page layout="Dining" {...props} /> } />
                    <Route path="/Home/:destination/:resort" exact render={  (props) => <Page layout="Resort" {...props}      /> } />
                    <Route path="/booking_request" component={ BookYourStay } />
                    <Route path="/sitemap" render={ (props) => <Page layout="SiteMap" { ...props } /> } />
                    <Route path="/map/:destination" render={ (props) => <MapView { ...props } /> } />
                    <Route path="/map" excat render={ (props) => <MapView { ...props } /> } />
                    <Route path="/gallery/:page_id/:resort" excat render={ (props) => <Page { ...props } layout="ResortGallery"/> } />
                    <Route path="/gallery" excat render={ (props) => <Page { ...props } layout="Gallery"/> } />
                    <Route path="/contactus" excat render={ (props) => <Form { ...props } form="ContactUs"/> } />
                    <Route path="/guest-survey" excat render={ (props) => <Form { ...props } form="GuestSurvey"/> } />
                    <Route path="/concepts" render={ (props) => <Page layout="Concepts" { ...props } /> } />
                    <Route path="/grand-edition" render={ (props) => <Page  layout="GrandEdition" { ...props } /> } />
                    <Route path="/select-concept" render={ (props) => <Page layout="SelectConcept" { ...props } /> } />
                    <Route path="/aboutus" render={ (props) => <Page layout="Aboutus" { ...props } /> } />
                    <Route path="/awards" render={ (props) => <Page layout="Awards" { ...props } /> } />
                    <Route path="/trustyou/:resort" render={ (props) => <TrustYou { ...props } /> } />
                    <Route path="/trustyou" exact render={ (props) => <TrustYou { ...props } /> } />
                    <Route path="/news" exact render={ (props) => <News { ...props } /> } />
                    <Route path="/news/:pagetitle/:page_id" render={ (props) => <Page { ...props } /> } />
                    <Route path="/files/" render={ ({location}) => window.location = `https://www.sunrise-resorts.com${location.pathname}?l=d` }/>
                    <Route component={NotFoundPage} />
                </Switch>
            </div>
        )
    }
}

//layout={ AwardPage }
                    //<Route path="/awards" component={AwardsList} />
                // <CSSTransitionGroup
                //     component="div"
                //     className="transition-container"
                //     transitionName={this.getAnimation()}
                //     transitionEnterTimeout={this.getAnimationSpeed()}
                //     transitionLeaveTimeout={this.getAnimationSpeed()}
                // >
                // </CSSTransitionGroup>
                // <Sidenav sidebar={ <Nav /> } onClose={close} onOpen={open}>
                // </Sidenav>


export default withRouter(connect( 
    state =>({
        browser: state.browser,
        overlay: state.app.overlay,
        scroll: state.app.scroll,
    }),
    dispatch => { 
        return { 
            _toggle_overlay: (payload) => { dispatch(toggleOverlay(payload))},
            _update_scroll: (payload) => { dispatch(updateScroll(payload))},
            updateBooking: (payload) => { dispatch(updateBooking(payload))}
        } 
    }
)(MasterLayout));




// WEBPACK FOOTER //
// ./src/components/masterlayout/index.js